import React from 'react';
import { Grid } from '@material-ui/core';
import { translateData, getToUrl } from 'utils/translation';
import { Button, Dialog, Div } from 'components/Ui';
import ProductList from 'containers/PrimoProducts/ProductListPage/ProductList';
import { INFORMATION_PAGE } from 'containers/PrimoCheckoutPage/constants';
import history from 'utils/history';
import styles from './styles.scss';

const EquipmentNotification = ({
  products,
  dispenserMissing,
  toggleDispeserMissing,
}) => (
  <Dialog
    size="small"
    onClose={toggleDispeserMissing}
    open={dispenserMissing}
    title={translateData('Notification')}
  >
    <div className={styles.modal}>
      <Div className={styles.title}>You might need one of these...</Div>
      <Div className={styles.text}>
        {
          "Looks like you've ordered a product that requires equipment. Here are some options:"
        }
      </Div>
      <Div className={styles.subText}>Compatible Equipment:</Div>
      <div className={styles.quickShop}>
        <ProductList
          products={products.slice(0, 2)}
          isProductsInit
          isQuickshop
          equipment
        />
        <Grid container spacing={2}>
          <div className={styles.buttons}>
            <Button
              text="Shop All"
              onClick={() =>
                history.push(getToUrl('/quick-shop/select-equipment', 'U22'))
              }
            />
            <Button
              text="No Thanks"
              className={styles.noThanks}
              onClick={() =>
                history.push(getToUrl(`/checkout/${INFORMATION_PAGE}`, 'U23'))
              }
            />
          </div>
        </Grid>
      </div>
    </div>
  </Dialog>
);
export default EquipmentNotification;
